// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs'

import { config } from './sentry.common.config'
import { isPrd } from './src/shared/util/env'

Sentry.init({
    ...config,
    // Route browser requests to Sentry through the Next.js tunnel route to circumvent ad-blockers
    tunnel: '/monitoring',
    // Add optional integrations for additional features
    integrations: [Sentry.replayIntegration()],

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: isPrd() ? 0.1 : undefined,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: isPrd() ? 1.0 : undefined,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
